import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A7196
 *
 * @param {SvgIconProps} props - svg props
 */
export const EditButtonIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M16.3782 6.44708L17.6662 7.6275C17.9755 7.91092 17.9922 8.39287 17.7033 8.69698L16.9264 9.51474C16.7341 9.71718 16.4132 9.72287 16.2138 9.52738L14.5916 7.9368C14.3933 7.74244 14.3914 7.42379 14.5873 7.22703L15.34 6.47088C15.6237 6.18585 16.0818 6.17535 16.3782 6.44708ZM6.98397 15.5188L6.76011 16.6296C6.69135 16.9708 6.98355 17.2761 7.32744 17.2224L8.4454 17.0477C9.06713 16.9506 9.64258 16.6604 10.0903 16.2182L15.56 10.8163C15.7601 10.6187 15.7579 10.295 15.5552 10.1001L13.9161 8.52451C13.7192 8.33523 13.4069 8.33898 13.2146 8.53293L7.79453 13.9992C7.38162 14.4156 7.09982 14.9439 6.98397 15.5188Z' fill='white'/>
        </SvgIcon>
    )
}

export default EditButtonIcon
